import { render, staticRenderFns } from "./ProfitList.vue?vue&type=template&id=c3c13b60&"
import script from "./ProfitList.vue?vue&type=script&lang=js&"
export * from "./ProfitList.vue?vue&type=script&lang=js&"
import style0 from "./ProfitList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports